<template>
    <div class="col-sm-12 form-group">
        <multilang-field
                type="text"
                :model="model"
                :model-id="textObject.id"
                :label="label"
                :lang="selectedLanguage.shortCode"
                :lang-id="selectedLanguage.id"
                :value="getTranslation('text')"
                :show-counts="true"
        />

        <div v-if="formerTranslation" class="small">
            <strong>Former translation:</strong>
            <span v-text="getFormerTranslation('translation_data_decoded.text.last_translation')"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        textField: Object,
        variant: Object,
        selectedLanguage: Object,
    },
    methods: {
        getTranslation(fieldName) {
            return _.get(this.translation, fieldName);
        },
        getFormerTranslation(fieldName) {
            return _.get(this.formerTranslation, fieldName);
        },
    },
    computed: {
        textObject() {
            if (this.variant) {
                return _.find(this.variant.texts, {'type': this.textField.value.type});
            }

            return this.textField.value;
        },
        translation() {
            return _.find(this.textObject.translations, {'language_id': this.selectedLanguage.id});
        },
        formerTranslation() {
            return _.find(this.textObject.translation_items, {'language_id': this.selectedLanguage.id});
        },
        model() {
            if (this.variant) {
                return 'ProductVariantText'
            }

            return 'ProductText';
        },
    }
}
</script>
